import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Container,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";

import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import TagsInput from "react-tagsinput";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Select from "react-select"
import showNotification from "../../helpers/show_notification";
import { postSubmitForm } from "../../helpers/forms_helper";
import { mapUnits } from "../../helpers/units";
import ReactSelect from "react-select";

const AddItem = (props) => {

  useEffect(() => {
    loadAllItems();
    loadAllCategories();
    loadAllUnits();
    loadAllBrands();
    loadAllLocations();
  }, []);

  const refContainer = useRef(null);
  const refNewCategoryForm = useRef(null);
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [unitValue, setUnitValue] = useState([])
  const [selectMore, setSelectMore] = useState(false)
  const [selecteRowUnit, setSelecteRowUnit] = useState([])

  const [isPremium, setIsPremium] = useState(false)
  const [isLoadingItems, setIsLoadingItems] = useState(false)
  const [allItems, setAllItems] = useState([]);
  const loadAllItems = async () => {
    try {
      setIsLoadingItems(true)
      let url = process.env.REACT_APP_BASEURL + "items/getall_for_master";
    let response = await postSubmitForm(url, { list_only: true });
    if (response.status === 1) {
      setAllItems(response.data);
    } else {
      showNotification(response.message, "Error");
    }
    } catch (error) {
     console.log(error);
    } finally {
      setIsLoadingItems(false);
    }
  };

  const [allLocations, setAllLocations] = useState([]);
  const loadAllLocations = async () => {
    let url = process.env.REACT_APP_BASEURL + "locations/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const formattedData = response.data.map(loc => ({
        value: loc._id,
        label: loc.name
      }));
      setAllLocations(formattedData);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const loadAllCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allBrands, setAllBrands] = useState([]);
  const loadAllBrands = async () => {
    let url = process.env.REACT_APP_BASEURL + "brands/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllBrands(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [selectedBrand, setSelectedBrand] = useState();
  const [newBrandModal, setNewBrandModal] = useState();
  const handleAddNewBrand = async (e, v) => {
    const object = {
      name: v.name,
    };
    let url = process.env.REACT_APP_BASEURL + "brands/insert";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      loadAllBrands();
      setSelectedBrand(v.name);
      setNewBrandModal(!newBrandModal);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allUnits, setAllUnits] = useState([]);
  const loadAllUnits = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemunits/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const data = response.data
      data.forEach((item) => {
        return (
          item.label = item.unit,
          item.value = item.unit,
          item._id = item._id
        )
      })
      setAllUnits(data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [viewUnitModal, setViewUnitModal] = useState();

  const [newCategoryModal, setNewCategoryModal] = useState();
  const [newSubCategories, setNewSubCategories] = useState([]);
  const handleAddNewCategory = async (e, v) => {
    try {
      const object = {
        category: v.name,
        sub_category: newSubCategories,
      };
      let url = process.env.REACT_APP_BASEURL + "itemcategories/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllCategories();
        setSelectedCategory(v.name);
        setAllSubCategories(newSubCategories);
        setNewSubCategories([]);
        setNewCategoryModal(!newCategoryModal);
        refNewCategoryForm.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };

  const [newSubCategoryModal, setNewSubCategoryModal] = useState();
  const handleAddNewSubCategory = async (e, v) => {
    try {
      const object = {
        category: selectedCategory,
        sub_category: v.name,
      };
      let url =
        process.env.REACT_APP_BASEURL + "itemcategories/insert_subcategory";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllCategories();
        let all_sub_cat = [...allSubCategories];
        all_sub_cat.push(v.name);
        setAllSubCategories(all_sub_cat);
        setSelectedSubCategory(v.name);
        setNewSubCategoryModal(!newSubCategoryModal);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };

  const [selectedLocation, setSelectedLocation] = useState()  
  const [isLoading , setIsLoading] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      if(selectedUnit?.length<=0) {
        showNotification("Please select atleast one Unit","Warning")
        return
      }
      if(!selectedLocation){
        showNotification("Please select location","Warning")
        return
      }
      setIsLoading(true)
      let payload = {
        name: v.name,
        brand: v.brand,
        category: v.category,
        sub_category: v.sub_category,
        description: v.description,
        threshold: v.threshold,
        unit_for_threshold: v.unit_for_threshold,
        unit_for_po:v.unit_for_po,
        unit_for_max_order:v.unit_for_max_order,
        remarks: v.remarks,
        is_premium_item:isPremium,
        location: selectedLocation.value
      }
      payload = {...payload, unit_levels: unitValue  }
      // console.log(payload,"pl")
      let url = process.env.REACT_APP_BASEURL + "Items/insert";
      let response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        showNotification(response.message, "Success");
        window.location.reload()
        setSelectedUnit([]);
        setUnitValue([])
        setIsPremium(false)
        setSelectedLocation()
        setSelectMore(false)
        refContainer.current.reset();
        loadAllItems();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };


  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Location"),
      dataField: "location.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "is_premium_item",
      text: props.t("Premium Item"),
      sort: true,
      formatter:(cel,row)=>{
        return row.is_premium_item ? "Yes" :"No"
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Unit for PO"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "second_latest_cost_price",
      text: props.t("Old Price"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "latest_cost_price",
      text: props.t("Latest Price"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Centre Threshold"),
      sort: true,
      formatter:(cel,row)=>{
        return (row.threshold+" "+row.unit_for_threshold)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value: allItems && allItems.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  const handleSelectUnit = (data,changedValue) => {
    // Select Logic
  //   if(changedValue.action === "select-option"){
  //     if (selectedUnit.length >= 8) {
  //       return showNotification("Max 8 units are allowed", "Warning")
  //     } else {
  //       if(unitValue?.length<=0) setUnitValue([{unit:data.unit,value:"1"}])
  //      setSelectedUnit(data)
  //   }
  // }
  if (changedValue.action === "select-option") {
    if (Array.isArray(data) && data.length > 8) {
      return showNotification("Max 8 units are allowed", "Warning")
    } else {
      setSelectedUnit(data);      
      if (!Array.isArray(data)) {
        // Single selection
        setUnitValue([{ unit: data.unit, value: "1" }]);
      } else {
        // Multiple selection
        const newUnitValue = data.map(unit => {
          const existingValue = unitValue.find(item => item.unit === unit.unit);
          return existingValue || { unit: unit.unit, value: "" };
        });
        setUnitValue(newUnitValue);
      }
    }
  }
    // Remove Logic
    if(changedValue.action === 'remove-value'){
      let UpdatedSelectedUnit = selectedUnit?.filter(item=>item.unit !== changedValue.removedValue.label);
      let UpdatedUnitValue = unitValue?.filter(item=>item.unit !== changedValue.removedValue.label);
     setUnitValue(UpdatedUnitValue);
     setSelectedUnit(UpdatedSelectedUnit)
    }
  
   
}
  const handleInput = (unit, value, ind) => {
    setUnitValue((prev) => {
      const updatedValues = [...prev];
      if (ind < updatedValues.length) {
        updatedValues[ind] = { unit: unit.unit, value: value };
      } else {
        for (let i = updatedValues.length; i < ind; i++) {
          updatedValues.push({});
        }
        updatedValues.push({ unit: unit.unit, value: value });
      }
      return updatedValues;
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Items")}
            breadcrumbItem={props.t("Add Items")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleValidSubmit} ref={refContainer}>
                    <CardTitle>{props.t("Add Items")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t("Enter the following details to add a new item")}
                    </CardSubtitle>
                    <Row>
                      <Col lg={6}>
                        <Row>
                          <Col lg={12}>
                            <AvField
                              name="name"
                              label={props.t("Name")}
                              placeholder={props.t("Enter Item Name")}
                              type="text"
                              validate={{ required: { value: true } }}
                              errorMessage={props.t("Name cannot be empty")}
                            />
                          </Col>
                          <Col lg={12}>
                            <Row>
                              <Col lg={9}>
                                <AvField
                                  name="category"
                                  label={props.t("Category")}
                                  type="select"
                                  value={selectedCategory}
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Category cannot be empty"
                                  )}
                                  onChange={(e) => {
                                    setSelectedCategory(e.target.value);
                                    if (e.target.value) {
                                      var categories = JSON.parse(
                                        JSON.stringify(allCategories)
                                      );
                                      let arr = categories.filter(
                                        (category) =>
                                          category.category === e.target.value
                                      );
                                      setAllSubCategories(arr[0].sub_category);
                                    } else {
                                      setAllSubCategories([]);
                                    }
                                  }}
                                >
                                  <option value="">
                                    {props.t("--Select Category--")}
                                  </option>
                                  {allCategories &&
                                    allCategories.map((category) => {
                                      return (
                                        <option value={category.category}>
                                          {category.category}
                                        </option>
                                      );
                                    })}
                                </AvField>
                              </Col>
                              <Col lg={3}>
                                <Label>&nbsp;</Label>
                                <br />
                                <Link
                                  class="btn btn-success waves-effect waves-light btn-sm"
                                  onClick={() => {
                                    setNewCategoryModal(!newCategoryModal);
                                  }}
                                >
                                  <i class="mdi mdi-file-plus"></i>{" "}
                                  {props.t("Add New")}
                                </Link>
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={12}>
                            <Row>
                              <Col lg={9}>
                                <AvField
                                  name="sub_category"
                                  label={props.t("Sub-Category")}
                                  type="select"
                                  required
                                  errorMessage={props.t(
                                    "Sub-Category cannot be empty"
                                  )}
                                  value={selectedSubCategory}
                                >
                                  <option value="">
                                    {props.t("--Select Sub-Category--")}
                                  </option>
                                  {allSubCategories &&
                                    allSubCategories.map((subcategory) => {
                                      return (
                                        <option value={subcategory}>
                                          {subcategory}
                                        </option>
                                      );
                                    })}
                                </AvField>
                              </Col>
                              <Col lg={3}>
                                <Label>&nbsp;</Label>
                                <br />
                                <Link
                                  class="btn btn-success waves-effect waves-light btn-sm"
                                  onClick={() => {
                                    if (selectedCategory) {
                                      setNewSubCategoryModal(
                                        !newSubCategoryModal
                                      );
                                    } else {
                                      showNotification(
                                        props.t("Select a category first!"),
                                        props.t("Error")
                                      );
                                    }
                                  }}
                                >
                                  <i class="mdi mdi-file-plus"></i>{" "}
                                  {props.t("Add New")}
                                </Link>
                              </Col>
                            </Row>
                          </Col>
                          

                          <Col lg={12}>
                            <AvField
                              name="remarks"
                              label={props.t("Remarks")}
                              placeholder={props.t("Enter Remarks")}
                              type="textarea"
                            />
                          </Col>

                          <Col lg={12}>
                            <AvField
                              name="description"
                              label={props.t("Description")}
                              placeholder={props.t("Enter Description")}
                              type="text"
                            />
                          </Col>

                        </Row>
                      </Col>

                      <Col lg={6}>
                        <Row>
                          <Col lg={12}>
                            <Row>
                              <Col lg={9}>
                                <AvField
                                  name="brand"
                                  label={props.t("Brand")}
                                  type="select"
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Brand cannot be empty"
                                  )}
                                  value={selectedBrand}
                                  onChange={(e) => {
                                    setSelectedBrand(e.target.value);
                                  }}
                                >
                                  {" "}
                                  <option value="">
                                    {props.t("--Select Brand--")}
                                  </option>
                                  {allBrands &&
                                    allBrands.map((brand) => {
                                      return (
                                        <option value={brand.name}>
                                          {brand.name}
                                        </option>
                                      );
                                    })}
                                </AvField>
                              </Col>
                              <Col lg={3}>
                                <Label>&nbsp;</Label>
                                <br />
                                <Link
                                  class="btn btn-success waves-effect waves-light btn-sm"
                                  onClick={() => {
                                    setNewBrandModal(!newBrandModal);
                                  }}
                                >
                                  <i class="mdi mdi-file-plus"></i>{" "}
                                  {props.t("Add New")}
                                </Link>
                              </Col>
                            </Row>
                          </Col>

                          <Col lg={12} className="mb-3">
                            <Row>
                              <Col lg={9}>
                                <Label>
                                  {props.t("Units")}
                                </Label>{" "}
                                <Select
                                  options={allUnits}
                                  value={selectedUnit}
                                  onChange={(data,changedValue) => handleSelectUnit(data,changedValue)}
                                  closeMenuOnSelect={true}
                                  classNamePrefix="select"
                                  isMulti={selectMore}
                                  // menuisOpen={true}
                                  required
                                  className="basic-multi-select"
                                />
                              </Col>
                              <Col lg={3}>
                                <Label>&nbsp;</Label>
                                <br />
                                <Button
                                  className="btn btn-success waves-effect waves-light btn-sm"
                                  onClick={() => setSelectMore(true)}
                                >
                                  <i class="mdi mdi-file-plus"></i>
                                  {props.t("Select More")}
                                </Button>
                              </Col>
                            </Row>

                            <Row>
                              {Array.isArray(selectedUnit) && selectedUnit?.map((unit, ind) => {
                                if (ind > 0) {
                                  const prevUnit = selectedUnit[ind - 1].unit
                                  const updatedValue = unitValue.find(obj => obj.unit === unit.unit)?.value || "";
                                  return (
                                    <>
                                      <Col lg={6} xl={4} md={6} sm={6}key={ind}  >
                                       <div style={{width:"200px",height:"35px"}} 
                                       className=" d-flex justify-content-between mt-2 mr-2 py-2 badge-soft-success badge badge-success badge-pill">

                                       <div style={{ width: "30%" }} className="">
                                          <Label>{"1 " + prevUnit + "     = "}</Label>
                                        </div>

                                        <div style={{ width: "30%",height: "10px" }}>
                                          <AvField
                                            name={`${unit.unit}`}
                                            type="number"
                                            className="form-control"
                                            value={updatedValue}
                                            style={{ height: "25px", }}
                                            validate={{
                                              required: {
                                                value: true,
                                                errorMessage: props.t(
                                                  "Formula required."
                                                ),
                                              },
                                              pattern: {
                                                value: "^[0-9]+$",
                                                errorMessage: props.t(
                                                  "Only numbers are allowed."
                                                ),
                                              },
                                            }}
                                            onChange={(e) => handleInput(unit, e.target.value,ind)}
                                          />

                                        </div>
                                        <div style={{ width: "30%" }}>
                                          <Label>{unit.unit}</Label>
                                        </div>
                                       </div>
                                      </Col>
                                    </>
                                  )
                                } else {
                                  return
                                }
                              })}
                            </Row>

                          </Col>

                          <Col lg={6}>
                                <AvField
                                  name="unit_for_po"
                                  label={props.t("Unit for PO")}
                                  type="select"
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Unit for PO required "
                                  )}
                                  
                                >
                               
                                  <option value="">
                                    {props.t("--Select Unit--")}
                                  </option>
                                  {selectedUnit.length>1 ?
                                    (selectedUnit?.map((item) => {
                                      return (
                                        <option value={item.unit}>
                                          {item.unit}
                                        </option>
                                      );
                                    }))
                                  :(
                                    <option value={selectedUnit.unit}>
                                    {selectedUnit.unit}
                                  </option>
                                  )}
                                </AvField>
                              </Col>

                              <Col lg={6}>
                                <AvField
                                  name="unit_for_threshold"
                                  label={props.t("Unit for Cr.Thrsld")}
                                  type="select"
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Unit for threshold required "
                                  )}
                                  
                                >
                               
                                  <option value="">
                                    {props.t("--Select Unit--")}
                                  </option>
                                  {selectedUnit.length>1 ?
                                    (selectedUnit?.map((item) => {
                                      return (
                                        <option value={item.unit}>
                                          {item.unit}
                                        </option>
                                      );
                                    }))
                                  :(
                                    <option value={selectedUnit.unit}>
                                    {selectedUnit.unit}
                                  </option>
                                  )}
                                </AvField>
                              </Col>
                              <Col lg={6}>
                                <AvField
                                  name="unit_for_max_order"
                                  label={props.t("Ordering Unit/Max Order Unit")}
                                  type="select"
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Ordering Unit/Max Order Unit is required "
                                  )}
                                  
                                >
                               
                                  <option value="">
                                    {props.t("--Select Unit--")}
                                  </option>
                                  {selectedUnit.length>1 ?
                                    (selectedUnit?.map((item) => {
                                      return (
                                        <option value={item.unit}>
                                          {item.unit}
                                        </option>
                                      );
                                    }))
                                  :(
                                    <option value={selectedUnit.unit}>
                                    {selectedUnit.unit}
                                  </option>
                                  )}
                                </AvField>
                              </Col>
                         
                              <Col lg={6}>
                                <AvField
                                  name="threshold"
                                  label={props.t("Cr. Threshold Qty.")}
                                  placeholder={props.t(
                                    "Enter Threshold Quantity for Centre"
                                  )}
                                  type="number"
                                  validate={{
                                    required: {
                                      value: true,
                                      errorMessage: props.t(
                                        "Threshold cannot be empty."
                                      ),
                                    },
                                    pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: props.t(
                                        "Only numbers are allowed."
                                      ),
                                    },
                                  }}
                                />
                              </Col>

                       
                              <Col lg={6} md={6}>
                        <Label>{props.t("Location")}</Label>
                        <ReactSelect
                          name="location"
                          options={allLocations}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={selectedLocation}
                          onChange={setSelectedLocation}
                          placeholder={props.t("Select Location...")}
                        />
                      </Col>
                          <Col lg={6} className="mt-2">
                                                <AvRadioGroup
                                                inline
                                                name="is_premium_item"
                                                required
                                                errorMessage={props.t("Select an option")}
                                                >
                                                <Label>{props.t("Premium Item ?")}</Label>
                                                <br />
                                                <AvRadio
                                                    onChange={(e, v) => {
                                                    setIsPremium(true);
                                                    }}
                                                    label="Yes"
                                                    value="Yes"
                                                />
                                                <AvRadio
                                                    onChange={(e, v) => {
                                                    setIsPremium(false);
                                                    }}
                                                    label="No"
                                                    value="No"
                                                />
                                                </AvRadioGroup>
                            </Col>

                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <hr />
                        <FormGroup className="mb-0 text-center">
                        <div>
                        <Button type="submit" color="primary" className="mr-1" disabled={isLoading} style={{width:"100px"}}>
                          { isLoading ? <Spinner size={"sm"}/> :props.t("Submit")}
                        </Button>
                      </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>

                  {/* Brand Modal */}
                  <Modal
                    size="md"
                    isOpen={newBrandModal}
                    toggle={() => setNewBrandModal(!newBrandModal)}
                  >
                    <ModalHeader
                      toggle={() => setNewBrandModal(!newBrandModal)}
                    >
                      {props.t("Add new brand")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewBrand(e, v);
                                }}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Name of Brand") + " *"}
                                      placeholder={props.t("Enter Brand Name")}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty."
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>

                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  {/* Open View Unit Modal */}
                  <Modal
                    size="md"
                    isOpen={viewUnitModal}
                    toggle={() => setViewUnitModal(!viewUnitModal)}
                  >
                    <ModalHeader toggle={() => setViewUnitModal(!viewUnitModal)}>
                      {props.t("View Units")}
                    </ModalHeader>
                    <ModalBody>
                              
                                <>
                             
                                 
                                      <Row >
                                       <Col xl ={12} lg={12} md={12} sm={12} >
                              {Array.isArray(selecteRowUnit) && selecteRowUnit?.map((unit, ind) => {
                                if (ind > 0) {
                                  const prevUnit = selecteRowUnit[ind - 1].unit
                                  return (
                                    <>
                                     
                                        <li>
                                             <Label>{"1 " + prevUnit + " = " + unit.value + " "+ unit.unit}</Label>
                                        </li> 
                                    </>
                                  )
                                } else {
                                  return
                                }
                              })}
                                       </Col>
                            </Row>
                                </>
                           
                            </ModalBody>
                  </Modal>

                  {/* Category Modal  */}
                  <Modal
                    size="md"
                    isOpen={newCategoryModal}
                    toggle={() => setNewCategoryModal(!newCategoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setNewCategoryModal(!newCategoryModal)}
                    >
                      {props.t("Add new category")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewCategory(e, v);
                                }}
                                ref={refNewCategoryForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Category")}
                                      placeholder={props.t(
                                        "Enter Category Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <Label>
                                      {props.t("Sub-Category Name")}
                                    </Label>{" "}
                                    ({props.t("press ENTER/TAB to add")})
                                    <TagsInput
                                      value={newSubCategories}
                                      onChange={(tags) => {
                                        setNewSubCategories(tags);
                                      }}
                                      onlyUnique={true}
                                      inputProps={{
                                        className: "react-tagsinput-input",
                                        placeholder: props.t("Add..."),
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  {/* subcategory Modal */}
                  <Modal
                    size="md"
                    isOpen={newSubCategoryModal}
                    toggle={() => setNewSubCategoryModal(!newSubCategoryModal)}
                  >
                    <ModalHeader
                      toggle={() =>
                        setNewSubCategoryModal(!newSubCategoryModal)
                      }
                    >
                      {props.t("Add new sub-category")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewSubCategory(e, v);
                                }}
                                ref={refNewCategoryForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Sub-Category")}
                                      placeholder={props.t(
                                        "Enter Sub-Category Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>

                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Existing Items")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all your existing items here")}
                  </CardSubtitle>
                  <ToolkitProvider
                    keyField="_id"
                    data={allItems && allItems}
                    columns={columns}
                  >
                    {(propst) => (
                      <div>
                        <BootstrapTable
                          {...propst.baseProps}
                          pagination={paginationFactory(pagination_options)}
                          noDataIndication={isLoadingItems ? <Spinner size={"md"} /> :props.t("No items to display.")}
                          striped
                          hover
                          condensed
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(AddItem)));